import { render, staticRenderFns } from "./UntilNextRoundCounter.vue?vue&type=template&id=10106ea2&scoped=true&"
import script from "./UntilNextRoundCounter.vue?vue&type=script&lang=js&"
export * from "./UntilNextRoundCounter.vue?vue&type=script&lang=js&"
import style0 from "./UntilNextRoundCounter.vue?vue&type=style&index=0&id=10106ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10106ea2",
  null
  
)

export default component.exports